<template>
  <div :class="{'d-none': !ativo}">
    <ItemLista
      v-for="(categoria, index) in categorias"
      :key="index"
      :height="50"
      class="d-flex align-center"
    >
      <div class="col-7 pa-0 d-flex align-center pl-12">
<!--        <div class="cursor-pointer" @click="selecionar(categoria)">-->
<!--          <v-icon v-if="estaSelecionado(categoria)" color="#142454" v-text="'mdi-checkbox-marked'" />-->
<!--          <v-icon v-else color="#142454" v-text="'mdi-checkbox-blank-outline'" />-->
<!--        </div>-->

        <p v-text="categoria.nome_categoria" :title="categoria.nome_categoria" class="informacao pl-2 pr-3 text-truncate" />
      </div>

      <div class="col-5 pa-0">
        <p class="pa-0 informacao">
          <span class="descricao">Quantidade:&nbsp;</span>
          <span class="valor" v-text="formatarValor(categoria.quantidade)" />
        </p>

        <p class="pa-0 mt-1 informacao">
          <span class="descricao">Preço unitário:&nbsp;</span>
          <span class="valor" v-text="`${formatarValorMonetario(categoria.preco_custo)}`" />
        </p>
      </div>
    </ItemLista>
  </div>
</template>

<script>
import ItemLista from "./ItemLista";
import {buscarCategoriasFornecedorCotacao} from '@/api/compras/MateriaPrima.js';
import {formatarValor, formatarValorMonetario, logout} from "@/helpers";

export default {
  name: "CategoriasAtendidas",
  components: {ItemLista},
  props: {
    fornecedor: Object,
    ativo: Boolean,
    fornecedor_esta_selecionado: Boolean,
  },
  data: () => ({
    categorias: []
  }),
  watch: {
    ativo() {
      if (!this.ativo || this.categorias.length > 0) return;
      this.buscarCategoriasCotacaoFornecedor();
    },
    // categorias() {
    //   if (!this.ativo || !this.fornecedor_esta_selecionado) return;
    //   this.selecionar();
    // },
    // fornecedor_esta_selecionado() {
    //   if (!this.ativo) return;
    //
    //   if (this.fornecedor_esta_selecionado && this.fornecedor.categorias.length === 0) {
    //     this.selecionar()
    //   }
    //
    //   if (!this.fornecedor_esta_selecionado && this.fornecedor.categorias.length > 0) {
    //     this.fornecedor.categorias = [];
    //   }
    // }
  },
  methods: {
    formatarValor,
    formatarValorMonetario,
    buscarCategoriasCotacaoFornecedor() {
      const {id_pedido, id_fornecedor} = this.fornecedor;

      this.$store.dispatch('loading/addRequisicao',
        buscarCategoriasFornecedorCotacao(id_pedido, id_fornecedor)
          .then(categorias => this.categorias = categorias)
          .catch(logout)
      );
    },
    estaSelecionado(categoria) {
      if (!this.fornecedor_esta_selecionado) return false;

      const callback = item => item.id_categoria === categoria.id_categoria;
      return this.fornecedor.categorias.some(callback);
    },
    // selecionar(categoria = null) {
    //   if (!categoria) {
    //     this.fornecedor.categorias = this.categorias.map(item => Object.assign({}, item));
    //   } else if (this.estaSelecionado(categoria)) {
    //     const callback = item => item.id_categoria !== categoria.id_categoria;
    //     this.fornecedor.categorias = this.fornecedor.categorias.filter(callback);
    //   } else {
    //     this.fornecedor.categorias.push(categoria);
    //   }
    //
    //   if (!this.fornecedor_esta_selecionado || this.fornecedor.categorias.length === 0) {
    //     this.$emit('selecionar', this.fornecedor);
    //   }
    // }
  }
}
</script>

<style scoped>

</style>
